import type { ElementType, ReactNode } from 'react';
import { cx } from '../lib/cx';
import styles from './TerminalWindow.module.css';

type Props = {
  /** Title bar text, e.g. "seax@dev: ~". Ignored when `header` is given. */
  title?: string;
  /** Replaces the default title bar contents (used for code tabs / package cards). */
  header?: ReactNode;
  /** Show the `_ □ ×` window controls on the right. */
  controls?: boolean;
  /** Render as a different element, e.g. "article". */
  as?: ElementType;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
};

/** Dark "terminal" frame: title bar on top, slot body below. */
export function TerminalWindow({
  title = 'seax@dev: ~',
  header,
  controls = true,
  as: Tag = 'div',
  className,
  bodyClassName,
  children,
}: Props) {
  return (
    <Tag className={cx(styles.window, className)}>
      <div className={styles.bar}>
        {header ?? (
          <>
            <span className={styles.title}>{title}</span>
            {controls && (
              <span aria-hidden="true" className={styles.controls}>
                <span>_</span>
                <span>□</span>
                <span>×</span>
              </span>
            )}
          </>
        )}
      </div>
      <div className={cx(styles.body, bodyClassName)}>{children}</div>
    </Tag>
  );
}
